// data/quizQuestions.js
export const quizQuestions = [
    {
      "question": "What is the first step in the DRSABCD action plan?",
      "answers": ["Danger", "Response", "Send for help", "Airway"],
      "correctAnswer": 0,
      "explanation": "The first step is to ensure the area is safe for both the rescuer and the casualty, which is 'Danger'.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "If a person is unresponsive and not breathing normally, what should you do next?",
      "answers": ["Check for a pulse", "Start CPR", "Call 000", "Give rescue breaths"],
      "correctAnswer": 2,
      "explanation": "You should call 000 immediately to get emergency help on the way.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "How many chest compressions should be performed per minute during CPR?",
      "answers": ["60-80", "80-100", "100-120", "120-140"],
      "correctAnswer": 2,
      "explanation": "Chest compressions should be performed at a rate of 100-120 per minute.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What is the recommended compression depth for adult CPR?",
      "answers": ["At least 2 cm", "At least 5 cm", "At least 10 cm", "At least 15 cm"],
      "correctAnswer": 1,
      "explanation": "Chest compressions should be at least 5 cm deep but not more than 6 cm.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What should you do if a person is not breathing normally but has a pulse?",
      "answers": ["Start CPR", "Give rescue breaths", "Place in the recovery position", "Monitor and reassess"],
      "correctAnswer": 2,
      "explanation": "If the person has a pulse but is not breathing normally, place them in the recovery position and monitor their condition.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "When should you use an Automated External Defibrillator (AED)?",
      "answers": ["Only for children", "Only if the person is conscious", "Only if you are trained", "As soon as it is available for a person in cardiac arrest"],
      "correctAnswer": 3,
      "explanation": "An AED should be used as soon as it is available for a person in cardiac arrest, regardless of your training level.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "How often should CPR skills be renewed in Australia?",
      "answers": ["Every 6 months", "Every 12 months", "Every 2 years", "Every 5 years"],
      "correctAnswer": 1,
      "explanation": "CPR skills should be renewed every 12 months, as recommended by the First Aid in the Workplace Code of Practice and the Australian Resuscitation Council guidelines.",
      "sources": ["https://www.stjohnvic.com.au/first-aid-training/first-aid-courses/hltaid009-provide-cardiopulmonary-resuscitation/"]
    },
    {
      "question": "What is the ratio of compressions to rescue breaths for adult CPR?",
      "answers": ["15:1", "30:2", "30:5", "15:2"],
      "correctAnswer": 1,
      "explanation": "The recommended ratio is 30 chest compressions to 2 rescue breaths for adult CPR.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What should you do if a person is choking and becomes unresponsive?",
      "answers": ["Perform abdominal thrusts", "Start CPR", "Call 000", "All of the above"],
      "correctAnswer": 3,
      "explanation": "If a person is choking and becomes unresponsive, perform CPR and call 000 immediately.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "How should you position your hands when performing adult CPR?",
      "answers": ["One hand on the forehead", "One hand on the chest", "Two hands on the centre of the chest", "Two fingers on the chest"],
      "correctAnswer": 2,
      "explanation": "Place the heel of one hand on the centre of the chest, then place your other hand on top. Keep arms straight, shoulders directly above hands.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "When should you stop performing CPR?",
      "answers": ["When the person starts breathing normally", "When emergency services arrive", "When you are physically exhausted", "All of the above"],
      "correctAnswer": 3,
      "explanation": "You should continue CPR until one of these conditions is met.",
      "sources": ["https://resus.org.au/"]
    },
    {
      "question": "How should you perform CPR on an infant?",
      "answers": ["Use two fingers on the centre of the chest", "Use the heel of one hand", "Use both hands", "Do not perform CPR on infants"],
      "correctAnswer": 0,
      "explanation": "For infants, use two fingers to compress the chest about one-third the depth.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What should you do after applying an AED shock?",
      "answers": ["Stop CPR and wait", "Start rescue breaths only", "Resume CPR immediately", "Call emergency services again"],
      "correctAnswer": 2,
      "explanation": "After a shock, continue CPR starting with chest compressions.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "What is the purpose of rescue breaths in CPR?",
      "answers": ["To cool the body", "To remove airway blockages", "To provide oxygen to the lungs", "To relax the patient"],
      "correctAnswer": 2,
      "explanation": "Rescue breaths provide essential oxygen to a person who is not breathing.",
      "sources": ["https://resus.org.au/"]
    },
    {
      "question": "How long should each rescue breath last?",
      "answers": ["About 1 second", "About 3 seconds", "As long as you can blow", "Only until the chest moves"],
      "correctAnswer": 0,
      "explanation": "Each breath should be given over approximately 1 second and make the chest rise.",
      "sources": ["https://resus.org.au/"]
    },
    {
      "question": "What is the correct hand placement for chest compressions?",
      "answers": ["Over the upper abdomen", "On the lower half of the breastbone", "On the left side of the chest", "Directly under the rib cage"],
      "correctAnswer": 1,
      "explanation": "Place hands on the lower half of the sternum, avoiding the xiphoid process.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "If alone with an unresponsive adult, what is the correct first action?",
      "answers": ["Start chest compressions", "Check for breathing and call 000", "Find an AED", "Give rescue breaths"],
      "correctAnswer": 1,
      "explanation": "Check for responsiveness and breathing, then call 000 before beginning CPR.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "Why is it important to allow full chest recoil during compressions?",
      "answers": ["It prevents injury", "It looks better", "It allows the heart to refill with blood", "It's not important"],
      "correctAnswer": 2,
      "explanation": "Full recoil between compressions is essential for effective blood flow.",
      "sources": ["https://resus.org.au/"]
    },
    {
      "question": "What does the 'R' in DRSABCD stand for?",
      "answers": ["Rescue", "Response", "Resuscitation", "Recovery"],
      "correctAnswer": 1,
      "explanation": "The 'R' stands for Response - checking if the person is conscious and responsive.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "What is the minimum age for learning CPR in Australia?",
      "answers": ["8 years old", "10 years old", "12 years old", "There is no minimum age"],
      "correctAnswer": 3,
      "explanation": "There is no minimum age for learning CPR, though the techniques may be adapted for younger learners.",
      "sources": ["https://www.stjohnwa.com.au/first-aid-training"]
    },
    {
      "question": "What is the primary goal of CPR?",
      "answers": ["To restart the heart", "To maintain circulation until medical help arrives", "To clear blocked airways", "To prevent further injury"],
      "correctAnswer": 1,
      "explanation": "CPR maintains vital blood flow to organs, especially the brain, until advanced medical care arrives.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "How often should you check for signs of life during CPR?",
      "answers": ["Every 30 seconds", "Every 2 minutes", "Only when the AED advises", "Continuously during compressions"],
      "correctAnswer": 2,
      "explanation": "Only check for signs of life when prompted by the AED or when the person shows obvious signs of recovery.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What is the correct depth for chest compressions on a child?",
      "answers": ["At least 3 cm", "At least 4 cm", "At least 5 cm", "Same as adult"],
      "correctAnswer": 1,
      "explanation": "For children, compress the chest at least 4 cm (about one-third of the chest depth).",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What should you do if you are not trained in rescue breathing?",
      "answers": ["Don't perform CPR", "Perform compressions only", "Wait for paramedics", "Try your best at rescue breathing"],
      "correctAnswer": 1,
      "explanation": "Compression-only CPR is better than no CPR. Focus on continuous chest compressions.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What does the 'S' in DRSABCD stand for?",
      "answers": ["Safety", "Send for help", "Shock", "Support"],
      "correctAnswer": 1,
      "explanation": "The 'S' stands for Send for help - calling 000 and getting an AED if available.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "What is the recovery position used for?",
      "answers": ["Unconscious but breathing normally", "During CPR", "After successful resuscitation", "For choking victims"],
      "correctAnswer": 0,
      "explanation": "The recovery position is used for unconscious people who are breathing normally to keep their airway clear.",
      "sources": ["https://stjohnnsw.com.au/first-aid-tips/recovery-position"]
    },
    {
      "question": "How should you open an unconscious person's airway?",
      "answers": ["Lift the chin only", "Tilt the head back only", "Tilt the head back and lift the chin", "Turn the head to one side"],
      "correctAnswer": 2,
      "explanation": "Use the head tilt, chin lift technique to open the airway unless spinal injury is suspected.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What is the maximum time you should spend checking for breathing?",
      "answers": ["5 seconds", "10 seconds", "15 seconds", "30 seconds"],
      "correctAnswer": 1,
      "explanation": "Spend no more than 10 seconds checking for normal breathing.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What should you do if an AED advises 'no shock'?",
      "answers": ["Stop all resuscitation", "Continue CPR immediately", "Check for pulse", "Give rescue breaths only"],
      "correctAnswer": 1,
      "explanation": "If the AED advises no shock, continue CPR starting with chest compressions.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "What is the correct compression to ventilation ratio for two-rescuer CPR?",
      "answers": ["15:2", "30:2", "5:1", "10:2"],
      "correctAnswer": 1,
      "explanation": "The ratio remains 30:2 for two-rescuer adult CPR, allowing for more efficient delivery.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What does 'agonal breathing' indicate?",
      "answers": ["Normal breathing", "The person is recovering", "Cardiac arrest", "Choking"],
      "correctAnswer": 2,
      "explanation": "Agonal breathing (gasping, irregular breaths) is a sign of cardiac arrest and CPR should be started.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What should you do if you suspect spinal injury?",
      "answers": ["Perform normal CPR", "Don't move the person at all", "Use jaw thrust instead of head tilt", "Wait for paramedics"],
      "correctAnswer": 2,
      "explanation": "Use the jaw thrust technique to open the airway while minimizing neck movement.",
      "sources": ["https://stjohnnsw.com.au/first-aid-tips/spinal-injuries"]
    },
    {
      "question": "How long can the brain survive without oxygen?",
      "answers": ["1-2 minutes", "4-6 minutes", "10-15 minutes", "20-30 minutes"],
      "correctAnswer": 1,
      "explanation": "Brain damage can begin after 4-6 minutes without oxygen, making immediate CPR crucial.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What is the survival rate for out-of-hospital cardiac arrest in Australia?",
      "answers": ["Around 5%", "Around 12%", "Around 25%", "Around 50%"],
      "correctAnswer": 1,
      "explanation": "The survival rate for out-of-hospital cardiac arrest in Australia is approximately 12%.",
      "sources": ["https://resus.org.au/cardiac-arrest-registry/"]
    },
    {
      "question": "What should you do if the person vomits during CPR?",
      "answers": ["Stop CPR immediately", "Turn them on their side, clear airway, continue CPR", "Give more rescue breaths", "Wait for it to clear naturally"],
      "correctAnswer": 1,
      "explanation": "Quickly turn the person on their side, clear the airway, then resume CPR.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What does the 'A' in DRSABCD stand for?",
      "answers": ["Alert", "Airway", "Ambulance", "Assessment"],
      "correctAnswer": 1,
      "explanation": "The 'A' stands for Airway - ensuring the airway is clear and open.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "How should you deliver rescue breaths?",
      "answers": ["Quickly and forcefully", "Slowly over 1 second", "In short, sharp puffs", "As long as possible"],
      "correctAnswer": 1,
      "explanation": "Deliver each breath slowly over 1 second, watching for chest rise.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What is the Chain of Survival?",
      "answers": ["A CPR technique", "A sequence of actions that improve survival", "An emergency service protocol", "A type of defibrillator"],
      "correctAnswer": 1,
      "explanation": "The Chain of Survival is a sequence of actions that, when linked together, improve the chances of survival from cardiac arrest.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "When should you not perform CPR?",
      "answers": ["If the person is elderly", "If there are obvious signs of death", "If you're not confident", "If it's been more than 10 minutes"],
      "correctAnswer": 1,
      "explanation": "CPR should not be performed if there are obvious signs of death such as rigor mortis or decomposition.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What does the 'B' in DRSABCD stand for?",
      "answers": ["Blood pressure", "Breathing", "Bandages", "Body temperature"],
      "correctAnswer": 1,
      "explanation": "The 'B' stands for Breathing - checking if the person is breathing normally.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "How should you position yourself when performing CPR?",
      "answers": ["Kneel beside the person's head", "Kneel beside the person's chest", "Stand beside the person", "Sit beside the person"],
      "correctAnswer": 1,
      "explanation": "Kneel beside the person's chest with your shoulders directly over your hands.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What is the most common cause of cardiac arrest in adults?",
      "answers": ["Choking", "Heart attack", "Drowning", "Electric shock"],
      "correctAnswer": 1,
      "explanation": "Heart attack (myocardial infarction) is the most common cause of cardiac arrest in adults.",
      "sources": ["https://resus.org.au/cardiac-arrest-registry/"]
    },
    {
      "question": "How do you know if your chest compressions are effective?",
      "answers": ["The person wakes up", "You feel tired", "The chest recoils completely", "You can feel a pulse"],
      "correctAnswer": 2,
      "explanation": "Effective compressions allow complete chest recoil between compressions and are delivered at the correct depth and rate.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What should you do if a child is choking but still conscious?",
      "answers": ["Start CPR immediately", "Give 5 back blows and 5 chest thrusts", "Call 000 and wait", "Give abdominal thrusts"],
      "correctAnswer": 1,
      "explanation": "For conscious choking children, give 5 sharp back blows followed by 5 chest thrusts.",
      "sources": ["https://stjohnnsw.com.au/first-aid-tips/choking"]
    },
    {
      "question": "What does the 'C' in DRSABCD stand for?",
      "answers": ["Circulation", "CPR", "Consciousness", "Call for help"],
      "correctAnswer": 1,
      "explanation": "The 'C' stands for CPR - starting cardiopulmonary resuscitation if needed.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "How long should you continue CPR?",
      "answers": ["Until you get tired", "For exactly 10 minutes", "Until help arrives or the person recovers", "Until the AED arrives"],
      "correctAnswer": 2,
      "explanation": "Continue CPR until emergency services arrive, the person starts breathing normally, or you become physically unable to continue.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What should you do if you're performing CPR alone and become exhausted?",
      "answers": ["Stop CPR completely", "Switch to rescue breaths only", "Continue but slower", "Try to find someone to help or switch"],
      "correctAnswer": 3,
      "explanation": "If possible, find someone to take over or switch every 2 minutes to maintain effective compressions.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What is the correct technique for infant rescue breaths?",
      "answers": ["Cover mouth and nose with your mouth", "Use mouth-to-mouth only", "Use a bag-mask device", "Don't give rescue breaths to infants"],
      "correctAnswer": 0,
      "explanation": "For infants, cover both the mouth and nose with your mouth to create a seal.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What should you do if an AED is not immediately available?",
      "answers": ["Wait for one to arrive", "Don't start CPR", "Start CPR immediately", "Send someone to find one but don't start CPR"],
      "correctAnswer": 2,
      "explanation": "Start CPR immediately. An AED can be applied when it becomes available.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "What does the 'D' in DRSABCD stand for?",
      "answers": ["Danger", "Defibrillation", "Drugs", "Diagnosis"],
      "correctAnswer": 1,
      "explanation": "The final 'D' stands for Defibrillation - using an AED if available and appropriate.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "How should you check for responsiveness?",
      "answers": ["Shake the person vigorously", "Tap shoulders and shout", "Check for pulse first", "Listen for breathing"],
      "correctAnswer": 1,
      "explanation": "Tap the person's shoulders firmly and shout 'Are you alright?' to check for responsiveness.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What is the compression rate for infant CPR?",
      "answers": ["80-100 per minute", "100-120 per minute", "120-140 per minute", "As fast as possible"],
      "correctAnswer": 1,
      "explanation": "Infant CPR compressions should be performed at 100-120 compressions per minute, same as adults.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What should you do if the person starts breathing normally during CPR?",
      "answers": ["Continue CPR", "Stop CPR and place in recovery position", "Give rescue breaths only", "Call 000 again"],
      "correctAnswer": 1,
      "explanation": "If the person starts breathing normally, stop CPR and place them in the recovery position while monitoring closely.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "How often should AED pads be replaced?",
      "answers": ["Every 6 months", "Every year", "Every 2 years", "Check expiry date"],
      "correctAnswer": 3,
      "explanation": "AED pads have expiry dates that should be checked regularly as part of AED maintenance.",
      "sources": ["https://stjohnnsw.com.au/aed-maintenance"]
    },
    {
      "question": "What is the most important factor in CPR effectiveness?",
      "answers": ["Speed of compressions", "Depth of compressions", "Minimizing interruptions", "Perfect technique"],
      "correctAnswer": 2,
      "explanation": "Minimizing interruptions to chest compressions is crucial for maintaining blood flow.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What should you do if you're unsure whether to start CPR?",
      "answers": ["Don't start", "Start CPR", "Wait and observe", "Call 000 and ask"],
      "correctAnswer": 1,
      "explanation": "If in doubt, start CPR. It's better to perform CPR on someone who doesn't need it than to withhold it from someone who does.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What is the survival benefit of bystander CPR?",
      "answers": ["No significant benefit", "Doubles or triples survival chances", "Increases survival by 10%", "Only helps if done perfectly"],
      "correctAnswer": 1,
      "explanation": "Immediate bystander CPR can double or triple the chances of survival from cardiac arrest.",
      "sources": ["https://resus.org.au/cardiac-arrest-registry/"]
    },
    {
      "question": "How should you perform CPR on a pregnant woman?",
      "answers": ["Don't perform CPR", "Same as normal but tilt her to the left", "Use less force", "Only give rescue breaths"],
      "correctAnswer": 1,
      "explanation": "Perform normal CPR but manually displace the uterus to the left or tilt the person slightly to improve blood flow.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What happens if you break ribs during CPR?",
      "answers": ["Stop CPR immediately", "Continue CPR - this is common", "Give rescue breaths only", "Call for advanced help"],
      "correctAnswer": 1,
      "explanation": "Rib fractures are common during CPR and you should continue - the brain needs blood flow more than ribs need protection.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What is the recommended training frequency for CPR instructors in Australia?",
      "answers": ["Every 6 months", "Every 12 months", "Every 18 months", "Every 3 years"],
      "correctAnswer": 2,
      "explanation": "CPR instructors should maintain their qualifications with training every 18 months.",
      "sources": ["https://www.stjohnvic.com.au/first-aid-training/become-a-trainer"]
    },
    {
      "question": "What should you do if the person regains consciousness during CPR?",
      "answers": ["Continue CPR for 2 more minutes", "Stop CPR immediately", "Give rescue breaths only", "Reduce compression force"],
      "correctAnswer": 1,
      "explanation": "If the person regains consciousness and is breathing normally, stop CPR and monitor them closely.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What is the maximum compression depth for adult CPR?",
      "answers": ["5 cm", "6 cm", "7 cm", "No maximum"],
      "correctAnswer": 1,
      "explanation": "Compressions should be at least 5 cm but should not exceed 6 cm to avoid injury.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "How should multiple rescuers coordinate during CPR?",
      "answers": ["Take turns every 30 compressions", "Switch every 2 minutes", "One person does compressions, one does breaths", "Switch when tired"],
      "correctAnswer": 1,
      "explanation": "Rescuers should switch roles every 2 minutes to prevent fatigue and maintain effective compressions.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What is the legal protection for people performing CPR in Australia?",
      "answers": ["No legal protection", "Protected if certified only", "Good Samaritan laws provide protection", "Protected only in hospitals"],
      "correctAnswer": 2,
      "explanation": "Good Samaritan laws in Australia protect people who provide emergency assistance in good faith.",
      "sources": ["https://stjohnnsw.com.au/first-aid-tips/good-samaritan-laws"]
    },
    {
      "question": "What should you do if an AED prompts 'check electrodes'?",
      "answers": ["Ignore and continue", "Remove and reattach pads", "Call emergency services", "Stop using the AED"],
      "correctAnswer": 1,
      "explanation": "Check that the electrode pads are properly attached to the person's skin and the AED.",
      "sources": ["https://stjohnnsw.com.au/guides-cpr"]
    },
    {
      "question": "How effective is hands-only CPR compared to conventional CPR?",
      "answers": ["Much less effective", "Slightly less effective", "Equally effective for the first few minutes", "More effective"],
      "correctAnswer": 2,
      "explanation": "Hands-only CPR is equally effective as conventional CPR in the first few minutes of cardiac arrest.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "What should you do if the emergency call handler gives different instructions?",
      "answers": ["Follow your training only", "Follow the call handler's instructions", "Do both simultaneously", "Ask them to repeat"],
      "correctAnswer": 1,
      "explanation": "Emergency call handlers are trained to provide appropriate guidance for your specific situation.",
      "sources": ["https://resus.org.au/guidelines/"]
    },
    {
      "question": "How long after cardiac arrest does brain death typically occur?",
      "answers": ["2-4 minutes", "4-6 minutes", "8-10 minutes", "15-20 minutes"],
      "correctAnswer": 2,
      "explanation": "Brain death typically occurs 8-10 minutes after cardiac arrest without CPR, though brain damage begins much earlier.",
      "sources": ["https://resus.org.au/guidelines/"]
    }
  ];